import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Typography,
  Row,
  Col,
  Spin,
  Alert,
  Result,
} from "antd";
import logofull from "../assets/logo.png";
import axios from "axios";
import { useHistory, useLocation } from 'react-router-dom'

const {Title} = Typography
const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  };
const ResetPassword = () => {
    const location = useLocation()
    const history = useHistory()
    const isLoggedIn = useSelector(
      (state) => state.user.isLoggedIn && state.user.jwt !== null
    );
    const isFetching = useSelector((state) => state.user.isFetching);

    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();



    const onFinish = (values) => {
        const query = new URLSearchParams(location.search);
        const code = query.get('code')
        setLoading(true);
        axios.post(process.env.REACT_APP_BACKEND+"/auth/reset-password",{
              code: code, 
              password: values.password,
              passwordConfirmation: values.confirmPassword,
            })
            .then(response => {
                setSent(true);
                setLoading(false);
                history.push('/signin');

            })
            .catch(error => {
                console.log('An error occurred:', error.response);
                let errorMessage = 'Network Error'
                if (error.response) {
                    errorMessage = error.response.data.message[0].messages[0].message
                }
                setError(true);
                setErrorMessage(errorMessage)
                setLoading(false);
            });
      };
    
      const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
      };

    const resetForm = (
        <Form
          {...layout}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
            <Row justify="center">
                <Title level={5}>Set new password</Title>
            </Row>
          <Form.Item
            label="New Password:"
            name="password"
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            label="Confirm Password:"
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              {
                required: true,
                message: 'Please confirm your password!',
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('Passwords do not match!');
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Row>
            <Button type="primary" htmlType="submit" block>
              Set new password
            </Button>
          </Row>
        </Form>
      );
    



    if (isLoggedIn) return <Redirect to="/" />
    return (
        <div className="reset-form">
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ minHeight: "100vh" }}
        >
        {error && (
          <Alert
            message={errorMessage}
            type="error"
            closable
            showIcon
            banner
            style={{ position: "absolute", top: "50px" }}
          />
        )}
          <Col>
            <Spin spinning={isFetching || loading} delay={100}>
              <img
                src={logofull}
                alt="Logo"
                className="logo-full"
                style={{ marginBottom: 15 }}
              />
              { sent ?
                <Result
                    status="success"
                    title="Password been set."
                    subTitle="You can now log in."
                />         
                :resetForm
              }
            </Spin>
          </Col>
        </Row>
      </div>
    )
}

export default ResetPassword
